import React from 'react';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';

import { parseShortDateTime } from '../../../../utils/dates';

export default function PatientDetails({ patientDetails }) {
  const otherPatientDetailsRender = () => {
    return (
      <div className="clinician-info-box">
        <Typography variant="h6" gutterBottom>
          Other Details
        </Typography>
        <List className="list-underline">
          <ListItem>
            <ListItemText primary="Title" />
            <span className="divider" />
            <ListItemText secondary={patientDetails.title || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Gender" />
            <span className="divider" />
            <ListItemText secondary={patientDetails.gender || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="NHS No" />
            <span className="divider" />
            <ListItemText secondary={patientDetails.nhsNumber || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="First and Last Name" />
            <span className="divider" />
            <ListItemText secondary={patientDetails.patientFullName || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Date of birth" />
            <span className="divider" />
            <ListItemText secondary={parseShortDateTime(patientDetails.dateOfBirth)} />
          </ListItem>
          <ListItem>
            <ListItemText primary="GP Practice Name" />
            <span className="divider" />
            <ListItemText secondary={patientDetails.gpPractice} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Pas Number" />
            <span className="divider" />
            <ListItemText secondary={patientDetails.pasNumber} />
          </ListItem>
        </List>
      </div>
    );
  };

  const contactDetailsRender = () => {
    return (
      <div className="clinician-info-box">
        <Typography variant="h6" gutterBottom>
          Contact Details
        </Typography>
        <List className="list-underline">
          <ListItem>
            <ListItemText primary="Address" />
            <span className="divider" />
            <ListItemText secondary={patientDetails.address.fullAddress || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Landline Phone Number" />
            <span className="divider" />
            <ListItemText secondary={patientDetails.contact.homeTelephoneDisplay || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Mobile Phone Number" />
            <span className="divider" />
            <ListItemText secondary={patientDetails.contact.mobileTelephoneDisplay || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Other Phone Number" />
            <span className="divider" />
            <ListItemText secondary={patientDetails.contact.workTelephoneDisplay || '-'} />
          </ListItem>
        </List>
      </div>
    );
  };

  const patientAddressRender = () => {
    return (
      <div className="clinician-info-box">
        <Typography variant="h6" gutterBottom>
          Address
        </Typography>
        <List className="list-underline">
          <ListItem>
            <ListItemText primary="Address line 1" />
            <span className="divider" />
            <ListItemText secondary={patientDetails.address.addressLine1 || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Address line 2" />
            <span className="divider" />
            <ListItemText secondary={patientDetails.address.addressLine2 || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Address line 3" />
            <span className="divider" />
            <ListItemText secondary={patientDetails.address.addressLine3 || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Town City" />
            <span className="divider" />
            <ListItemText secondary={patientDetails.address.townCity || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Post Code" />
            <span className="divider" />
            <ListItemText secondary={patientDetails.address.postCode || '-'} />
          </ListItem>
          <ListItem>
            <ListItemText primary="Access Details" />
            <span className="divider" />
            <ListItemText secondary={patientDetails.address.accessDetails || '-'} />
          </ListItem>
        </List>
      </div>
    );
  };

  return (
    <React.Fragment>
      {patientAddressRender()}
      {contactDetailsRender()}
      {otherPatientDetailsRender()}
    </React.Fragment>
  );
}
